<template>
  <div class="goodsManageSet">
    <div class="banner">
      <img src="../../../assets/images/banner1.png" alt="" />
    </div>
    <div class="breadcrumb flex-rowc">
      <div class="breadcrumb_item">辅助功能&内容管理</div>
      <div class="breadcrumb_item_arrow"></div>
      <div class="breadcrumb_item">知识付费内容管理</div>
    </div>

    <div class="main_content">
      <div class="tit">内容视频链接设置</div>
      <div class="block">
        <h1><span class="mark">*</span>视频标签</h1>
        <div class="input_box">
          <van-field
            v-model="formData.videotopic"
            placeholder="输入视频标签"
            @focus="inputFocus"
            @blur="inputBlur"
          />
        </div>
      </div>
      <div class="block">
        <!-- 商品详情编辑内容 -->
        <div class="product_details_edit">
          <!-- 编辑内容展示 -->
          <div class="product_details_content" v-if="formData.videourl != ''">
            <div class="product_details_item">
              <!-- 子内容操作 -->
              <div class="product_details_item_operate flex-between">
                <div class="txt">视频</div>
                <div class="operate_group flex-rowr">
                  <div class="btn flex-rowc" @click="formData.videourl = ''">
                    移除
                  </div>
                </div>
              </div>
              <!-- 子内容展示 -->
              <div class="product_details_item_content">
                <!-- 视频 -->
                <div class="video_box">
                  <van-uploader
                    @click-upload="clickUpload(item.id)"
                    :before-read="beforeReadVideo"
                    :after-read="addVideoContent"
                    :max-count="1"
                    class="flex-rowc"
                    accept="multiple"
                  >
                    <video :src="formData.videourl" controls></video>
                  </van-uploader>
                </div>
              </div>
            </div>
          </div>
          <!-- 编辑操作 -->
          <div
            class="product_details_operate flex-between"
            v-if="formData.videourl == ''"
          >
            <div class="txt">内容</div>
            <div class="operate_group flex-rowr">
              <div class="btn flex-rowc">
                <van-uploader
                  :before-read="beforeReadVideo"
                  :after-read="addVideoContent"
                  :max-count="1"
                  accept="multiple"
                >
                  + 新增视频内容
                </van-uploader>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="primary-button" @click="query">保存确认</div>
    <div class="primary-button return" @click="handleReturn">
      <i class="iconfont icon-yuyinjiantou"></i>返回
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { getUploadToken, encryptstringview } from "../../../api/api";
import {
  getKonwledgeVideoDetail,
  editKonwledgeVideo,
  addKonwledgeVideo,
} from "../../../api/knowledge";
export default {
  name: "kVideoDetail",
  data() {
    return {
      formData: {
        id: "",
        kpid: "",
        videotopic: "",
        videourl: "",
      },

      loading: false,
      loadingText: "请稍后",
    };
  },
  created() {
    let { routerList, OPENID } = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id, kpid } = JSON.parse(res.jsondata);
        console.log(id, kpid);
        this.formData.id = id;
        this.formData.kpid = kpid;
        if (id) {
          this.getDetail(id);
        }
      } else {
        this.$router.back();
      }
    },

    // 获得焦点
    inputFocus(e) {
      this.scrollTop = "-" + (e.srcElement.getBoundingClientRect().top - 200);
      this.isShowStyle = true;
    },
    // 失去焦点
    inputBlur() {
      this.isShowStyle = false;
    },

    getDetail(id) {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      this.loading = true;
      getKonwledgeVideoDetail({ id }).then((res) => {
        this.formData.videotopic = res.videotopic ? res.videotopic : "";
        this.formData.videourl = res.videourl ? res.videourl : "";

        this.loading = false;
        Toast.clear();
      });
    },

    /**
     * 编辑商品详情
     * **/
    // 3、新增视频内容
    // 上传之前
    beforeReadVideo(file) {
      const imgformat = /video\/(mp4)$/;
      if (!imgformat.test(file.type)) {
        this.$toast.fail("请上传视频");
        return false;
      }
      return true;
    },
    addVideoContent(e) {
      getUploadToken().then((res) => {
        var formData = new FormData();
        formData.append("name", "file");
        formData.append("key", res.key);
        formData.append("policy", res.policy);
        formData.append("OSSAccessKeyId", res.OSSAccessKeyId);
        formData.append("success_action_status", "200");
        formData.append("signature", res.signature);
        formData.append("file", e.file);
        const config = {
          onUploadProgress: this.setUploadProgress, // 将方法绑定到上传进度事件上
        };
        return new Promise((resolve, reject) => {
          axios
            .post("https://upload.vwingist.com/", formData, config)
            .then((response) => {
              // 请求成功的处理
              if (response.status === 200) {
                resolve(response.data);
                let videourl = res.host + "/" + res.key;
                this.formData.videourl = videourl;
              } else {
                reject("请求失败");
              }
            })
            .catch((error) => {
              reject(error);
            });
        });
      });
    },
    // 设置上传进度
    setUploadProgress(event) {
      // 进度处理逻辑
      const progress = Math.round((event.loaded / event.total) * 100);
      const toast = this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: `上传:${progress}%`,
      });
      if (progress == 100) {
        toast.clear();
      }
      // console.log("上传进度：", progress, "%");
    },

    handleReturn() {
      history.back();
    },

    query() {
      let { formData } = this;
      if (formData.videotopic == "") {
        this.$toast("请输入视频标题");
        return;
      }
      if (formData.videourl == "") {
        this.$toast("请上传视频");
        return;
      }
      const Toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      if (formData.id) {
        editKonwledgeVideo(formData).then((res) => {
          let data = res;
          if (data.result) {
            setTimeout(() => {
              Toast.clear();
              this.$toast.success(data.message);
            }, 500);
            // setTimeout(() => {
            //   history.back();
            // }, 1500);
          } else {
            this.$toast.fail(data.message || "服务器报错，请稍后～");
          }
        });
      } else {
        addKonwledgeVideo(formData).then((res) => {
          let data = res;
          if (data.result) {
            setTimeout(() => {
              Toast.clear();
              this.$toast.success(data.message);
            }, 500);
            // setTimeout(() => {
            //   history.back();
            // }, 1500);
          } else {
            this.$toast.fail(data.message || "服务器报错，请稍后～");
          }
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  padding-bottom: 420px;
  .breadcrumb {
    padding-bottom: 60px;
  }
  .main_content {
    .tit {
      text-align: center;
      font-size: 32px;
      font-weight: bold;
      margin-bottom: 50px;
    }
    .block {
      margin-bottom: 80px;
      .textarea_box {
        .van-cell {
          padding: 10px 0;
          width: 100%;
          height: 100%;
        }
      }
      h1 {
        text-align: center;
        font-weight: 400;
        margin-bottom: 20px;
        font-size: 30px;
      }
      .img_box {
        margin: auto;
        margin-top: 40px;
        text-align: center;
      }
      p {
        font-size: 22px;
        text-align: center;
        &.red {
          color: #ff0012;
        }
      }
    }
  }
  // 内容编辑
  .product_details_edit {
    padding: 0 50px 100px;
    font-size: 20px;
    color: #505050;
    .product_details_content {
      box-sizing: border-box;
      margin-bottom: 20px;
      .product_details_item {
        .product_details_item_operate {
          width: 100%;
          height: 60px;
          border: 1px solid #d2d2d2;
          font-size: 18px;
          padding: 0 22px;
          box-sizing: border-box;
          margin-bottom: 10px;
          .txt {
            font-size: 22px;
          }
          .operate_group {
            .btn {
              border: 1px solid #d2d2d2;
              height: 30px;
              padding: 0 14px;
              margin-left: 20px;
              &.disable {
                color: #c1c1c1;
              }
            }
          }
        }
        .product_details_item_content {
          padding: 15px 12px 40px;
          .txt_box {
            min-height: 150px;
            .van-cell {
              padding: 0;
            }
          }
          .pic_box,
          .video_box {
            padding-top: 25px;
            video {
              width: 100%;
            }
          }
        }
      }
    }
    .product_details_operate {
      border: 1px solid #d2d2d2;
      padding: 17px 21px 43px 23px;
      .txt {
        font-size: 22px;
        white-space: nowrap;
      }
      .btn {
        font-size: 18px;
        color: #ffffff;
        height: 40px;
        background: #1e1e1e;
        padding: 0 6px;
        white-space: nowrap;
        &:nth-child(2) {
          margin: 0 10px;
        }
      }
    }
  }
  .popup_add_wrap {
    font-size: 26px;
    .popup_add_content {
      .add_item {
        height: 100px;
        border-bottom: 2px solid #ededed;
        &:last-child {
          border-bottom: none;
        }
        .iconfont {
          font-size: 36px;
          margin-right: 10px;
        }
      }
    }
    .popup_add_cancle {
      height: 100px;
      border-top: 5px solid #ededed;
    }
  }
}
</style>